import { Component } from '@angular/core';

@Component({
  selector: 'app-billing-details',
  templateUrl: './billing-details.component.html',
  standalone: false,
})
export class BillingDetailsComponent {}
